export const getDateUtils = ({ pageContext }) => {
  if (!pageContext) {
    return {};
  }

  const accountTimeZoneOffsetMinutes = pageContext.UtcOffsetHours * 60;
  const localTimeZoneOffsetMinutes = (new Date()).getTimezoneOffset();
  const totalOffset = (localTimeZoneOffsetMinutes + accountTimeZoneOffsetMinutes) * 60000;


  const local2account = date =>
    new Date(date.getTime() + totalOffset);

  const account2local = date =>
    new Date(date.getTime() - totalOffset);

  return {
    dateUtils: {
      local2account,
      account2local,
    },
  };
};

